
import { Card, CardContent, CardHeader, CardFooter } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Store } from "lucide-react";

export function RecommendedDealersLoading() {
  return (
    <Card className="metal-card gold-theme border border-metal-light/20 overflow-hidden">
      {/* Header che corrisponde esattamente a RecommendedDealersHeader */}
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <h3 className="text-lg font-semibold flex items-center">
            <Store className="h-5 w-5 mr-2 text-metal" />
            Compro Oro Consigliati
            <Skeleton className="ml-2 h-5 w-12 rounded" />
          </h3>
          <p className="text-sm text-muted-foreground">Le migliori quotazioni in tempo reale</p>
        </div>
        <Skeleton className="h-8 w-8 rounded-full" />
      </CardHeader>
      
      {/* Content che corrisponde esattamente a RecommendedDealersList */}
      <CardContent className="p-0">
        <div className="divide-y divide-border/40">
          {Array.from({ length: 3 }).map((_, index) => (
            <div 
              key={index}
              className="p-4 group cursor-pointer transition-all hover:bg-accent/30 relative"
            >
              <div className="flex justify-between items-center mb-1">
                <Skeleton className="h-5 w-40" />
                <Skeleton className="h-5 w-16 rounded" />
              </div>
              
              <div className="flex items-center text-xs text-muted-foreground mb-2">
                <Skeleton className="h-3 w-3 mr-1 rounded-full" />
                <Skeleton className="h-4 w-32" />
              </div>
              
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-1">
                  <Skeleton className="h-4 w-16" />
                  <Skeleton className="h-4 w-8" />
                </div>
                
                <div className="flex items-center gap-1.5">
                  <Skeleton className="h-5 w-12 rounded" />
                  <Skeleton className="h-5 w-20 rounded" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
      
      {/* Footer che corrisponde esattamente a RecommendedDealersFooter */}
      <CardFooter className="flex items-center justify-between py-4 border-t">
        <div className="flex items-center">
          <Skeleton className="h-8 w-20 rounded" />
        </div>
        
        <Skeleton className="h-8 w-24 rounded" />
      </CardFooter>
    </Card>
  );
}
